import React from "react"
import ListingErrorMessage from "../../common/listing/ListingErrorComponent"
import NoResult from "../../common/listing/noresult.component.jsx"
import LoadingSpinner from "../../common/spinner/loading.component.jsx"
import { SearchPayload } from "../../state/search/SearchPayload"
import { BasicRow } from "./ListingTypes"
import StandardList from "./list.component"


type BulkActions = {
    "account-statements-creation": JSX.Element
    "contacts-updates": JSX.Element
    "bulk-delete": JSX.Element;
}

type StandardListProps = {
    className?: string
    headers: { data: (JSX.Element | string)[]; classNames: string[] }
    rows: BasicRow[]
    pageSize: number
    totalItemsCount: number
    showSelectionSize: boolean
    smallLine?: boolean
    footer?: { data: (JSX.Element | string)[]; classNames: string[] }
    footerClassName?: string
    selectable?: boolean
    bulkActions?: BulkActions
    object?: string
    searchData?: SearchPayload
}

type OwnProps = {
    standardListProps: StandardListProps
    showHeaders?:boolean
    search?: JSX.Element
    error?: Error
    isLoading: boolean
    footer?: JSX.Element
}

const ListingWrapper = (props: OwnProps) => {
    const { isLoading, error, standardListProps } = props
    const searchComponent = props.search ?? ""

    if (isLoading) {
        return <>
            {searchComponent}
            <LoadingSpinner />
        </>
    }

    if (error) {
        return <ListingErrorMessage errorMessage={error.message} />
    }

    if (standardListProps?.rows?.length === 0 && !props.showHeaders) {
        return <>
            {searchComponent}
            <NoResult noButton={true} />
        </>
    }

    return <>
        {searchComponent}
        <StandardList {...standardListProps} />
        {props.footer}
    </>
}

export default ListingWrapper


// WEBPACK FOOTER //
// ./src/common/listing/ListingWrapper.tsx